export default {
  setStatusItems(state, payload) {
    state.statusItems = payload;
  },
  setUserKbnMutation(state, payload) {
    state.user = payload;
  },
};
